// src/services/notificationService.js
import api from "../api/axios";

const BASE = "notifications";

const get = (url, params) => api.get(`${BASE}${url}`, { params }).then((r) => r.data);
const post = (url, body) => api.post(`${BASE}${url}`, body).then((r) => r.data);

export const notificationService = {
  // ───────── الأدمن: إشعار لكل الطلاب ─────────
  adminBroadcasts: () => get("/admin/broadcasts/"),
  sendAdminBroadcast: (data) => post("/admin/broadcasts/", data), // {title?, message, link?}

  // ───────── المدرس: رسالة لطلاب مجموعة ─────────
  groupBroadcasts: (groupId) => get(`/teacher/groups/${groupId}/broadcasts/`),
  sendGroupBroadcast: (groupId, data) =>
    post(`/teacher/groups/${groupId}/broadcasts/`, data), // {title?, message, link?}
};